import { CalendarManager, Guidance, ISetParams } from '@benzinga/calendar-manager';
import { Session } from '@benzinga/session';
import { injectLogos } from '../lib/utils';
import { logCalendarFetchFailure } from '../lib/utils/logCalendarFetchFailure';

const fetchGuidance = (
  session: Session,
  params: ISetParams = {},
  injectTickersLogos = true,
  pageSize = 100,
): Promise<Guidance[]> => {
  return session
    .getManager(CalendarManager)
    .getCalendarData('guidance', { ...params, pageSize })
    .then(res => {
      if (res.ok && res.ok.length) {
        return injectTickersLogos ? injectLogos(res.ok) : res.ok;
      }
      return [];
    })
    .catch(error => {
      logCalendarFetchFailure('guidance', error);
      return [];
    });
};

export { fetchGuidance };
